import React, { useMemo, useRef } from 'react'
import { MessageSwitchProps } from '../MessageSwitch'
import { MessageWrapper } from './MessageWrapper'
import parsed, { HTMLReactParserOptions } from 'html-react-parser'
import classNames from 'classnames'
import { useNarrow } from '~/utils/useNarrow'
import { MessageUser } from '~/service/chatConn/types'
import emojiToImg from '~/utils/emojiToImg'
import { useEmojiOnly } from '~/utils/hooks'

export type TextAnswerProps = MessageSwitchProps<MessageUser>

const Answer: React.FC<TextAnswerProps> = ({ ...props }) => {
  const emojiOnly = useEmojiOnly(props.message.content)
  const { message } = props
  const text = useMemo(() => emojiToImg(message.content), [])

  const ref = useRef<HTMLDivElement>(null)

  useNarrow(ref, props.parentWidth)

  const options = {
    replace: (node: any) => {
      if (node.type != 'tag') {
        return node
      }

      if (node.name == 'a' && node.attribs.target == '_blank') {
        return <a {...node.attribs}>{node.children[0].data}</a>
      }

      if (node.name == 'img' && node.attribs.class != 'emoji') {
        const onImgClick = (img: HTMLImageElement) => {
          // if (!window.isIframe) {
          // }
          // busZoomImg(img.src, img.getBoundingClientRect());
        }

        return (
          <a
            href={node.attribs.src}
            target="_blank"
            className="chat-message-singleImg"
          >
            <img
              {...node.attribs}
              tabIndex={0}
              aria-hidden
              onClick={e => {
                onImgClick(e.target as HTMLImageElement)
              }}
            />

            {/* <div className="chat-message-singleImg-magnify">
              <span className="fa fa-magnifying-glass" />
            </div> */}
          </a>
        )
      }
    },
  }

  return (
    <>
      <MessageWrapper
        {...props}
        className={classNames('is-answer', { 'is-emojiOnly': emojiOnly })}
        _ref={ref}
      >
        <span>{parsed(text, options)}</span>
      </MessageWrapper>
    </>
  )
}

export default Answer
